import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsClassificacaoFiscalClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/classificacao-fiscal');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Classificação Fiscal');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/classificacao-fiscal', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Classificação Fiscal');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/classificacao-fiscal', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Classificação Fiscal');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/classificacao-fiscal/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Classificação Fiscal');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/classificacao-fiscal/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Classificação Fiscal');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/classificacao-fiscal/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Classificação Fiscal');
    }
  }
}
